// extracted by mini-css-extract-plugin
export default {"w-full":"Item_w-full__Dyi-4","item":"Item_item__RDsv7","anchor":"Item_anchor__TcRpY","title":"Item_title__CSNCs"};